import Axios from "./axios";
export default {
    getHome(data) { //首页数据
        return Axios.get("/api/index/index", { params: data });
    },
    getSearch(data) { 
        return Axios.get("/api/index/search", { params: data });
    },
    getLoginurl(data) { //登录
        return Axios.get("/api/auth/loginurl", { params: data });
    },
    getMycertifyurl(data) { //认证
        return Axios.get("/api/user/mycertifyurl", { params: data });
    },
    getCates(data) { //建设
        return Axios.get("/api/index/cates", { params: data });
    },
    postLookNum(data) {
        return Axios.post("/api/article/view", data)
    },
    getDetilseNew(data) {
        return Axios.get("/api/article/detail", { params: data })
    },
    getLecturer(data) {
        return Axios.post("/api/coe-elegant/lecturer", data )
    },
    getUuid(data){
        return Axios.get("/api/index/getUuid",  { params: data } )
    },
    getShare(data){
        return Axios.get("/api/index/share",  { params: data } )
    }
   
};